import gql from 'graphql-tag';
import { getResumeFragment } from '~/jobiqo/components/Resume/graphql/fragments/resumeFragment';
import { ResumeFrontendFeatureFlags } from '~/jobiqo/components/Resume/graphql/resumeFeatureFlags';

export function getBookmarkedResumeQuery(
  currentOrganizationId: null | number = null,
  frontendFlags: ResumeFrontendFeatureFlags = {},
) {
  const RESUME_FRAGMENT = getResumeFragment(
    currentOrganizationId,
    true,
    frontendFlags,
  );

  return gql`
    ${RESUME_FRAGMENT}
    query getBookmarkedResumes(
      $limit: Int!
      $offset: Int
      $locale: String
      $recruiterId: Int
    ) {
      bookmarkedResumes(
        limit: $limit
        offset: $offset
        language: $locale
        recruiterId: $recruiterId
      ) {
        errors
        total
        resumes {
          ... on Resume {
            ...ResumeFragment
          }
        }
      }
    }
  `;
}
